import React, { useContext } from "react"

import { Header, HeaderYeni } from "./Header"

// Global styles and component-specific styles.
import "./global.css"
import { main } from "./main.module.css"
import GenericBreadcrumbs from "./Breadcrumb/GenericBreadcrumb"
import Footer from "./Footer/Footer"
import { Box, useMediaQuery,useTheme } from "@mui/material"
import { LoadingContext } from "../../context/LoadingContext"
import { Spin } from "antd"
//import AdBanner from "../Ads/AdBanner"




export default function Layout ({ children }) { 
  const theme = useTheme();

  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

   

  
  
  
  return (
  <Box sx={{justifyContent:'center',alignItems:'center'}}>

    


    <Header />
    {/*<GenericBreadcrumbs />*/}
    {/*<main className={main}>{children}</main>*/}
    <Box mx={'auto'} maxWidth={'lg'} sx={{paddingLeft: isLgDown ? 1 : 0,paddingRight: isLgDown ? 1 : 0}} >{children}</Box>
    <Footer />
  </Box>
)
}


export function LayoutSSR ({ children }) { 
  const theme = useTheme();

  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

  const {loading} = useContext(LoadingContext);

  
  
  
  return (
  <Box sx={{justifyContent:'center',alignItems:'center'}}>


    {/*<AdBanner />*/}

    <Header />
    {/*<GenericBreadcrumbs />*/}
    {/*<main className={main}>{children}</main>*/}
    <Spin spinning={loading} style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
        }}>{children}</Spin>

  
    
    <Footer />
  </Box>
)
}

